require('./order-items/order-items.scss');
var OrderItem = require('./order-item');
var OrderItems = Marionette.CollectionView.extend({
    className: 'fmcy-order-items row-flex clearfix',
    childView: OrderItem,
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                style: 'condensed'
            }
        );
    },
    childViewOptions: function(model, index) {
        var extraClassName = 'col-flex-xs-12';
        return {
            collection: this.options.collection,
            extraClassName: extraClassName,
            _appChannel: this.options._appChannel
        };
    },
    onRender: function() {
      var self = this;
        this.$el.addClass(this.options.style);
        this.listenTo(this.options._appChannel, 'orders:updated', function () {
            self.render();
        });
    }
});
module.exports = OrderItems;



/** WEBPACK FOOTER **
 ** ./assets/js/common/orders/order-items.js
 **/